import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import MobileTimer from './pages/MobileTimer';
import AdminDashboard from './pages/AdminDashboard';
import TimingRecords from './pages/TimingRecords';
import LiveTiming from './pages/LiveTiming';
import LiveResults from './pages/LiveResults';
import PublicResults from './pages/PublicResults';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData, token) => {
    setUser(userData);
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('lastSync');
    localStorage.removeItem('serverTimeOffset');
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={!user ? <Login onLogin={handleLogin} /> : <Navigate to="/" />} />
          <Route path="/live" element={<LiveTiming />} />
          <Route path="/results" element={<PublicResults />} />
          <Route path="/live-results" element={user ? <LiveResults user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
          <Route
            path="/"
            element={
              user ? (
                (user.active_role || user.role) === 'admin' ? (
                  <AdminDashboard user={user} onLogout={handleLogout} />
                ) : (user.active_role || user.role) === 'marshal' ? (
                  <MobileTimer user={user} onLogout={handleLogout} />
                ) : (user.active_role || user.role) === 'scorer' ? (
                  <TimingRecords user={user} onLogout={handleLogout} />
                ) : (
                  <Navigate to="/login" />
                )
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route path="/timer" element={user ? <MobileTimer user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
          <Route path="/admin" element={(user?.active_role || user?.role) === 'admin' ? <AdminDashboard user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
          <Route path="/records" element={user ? <TimingRecords user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;